import { render, staticRenderFns } from "./NewContractsDay.vue?vue&type=template&id=5f7545b9&scoped=true"
import script from "./NewContractsDay.vue?vue&type=script&lang=ts"
export * from "./NewContractsDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7545b9",
  null
  
)

export default component.exports